export default "__VITE_ASSET__CUQJR5cf__"